'use client';

import { createContext, Dispatch, PropsWithChildren, useEffect, useReducer } from 'react';

import { layoutReducer } from '@/reducers/layout';
import { ILayoutContextData, ILayoutReducerAction } from '@/types/layout';

export interface ILayoutContext {
  context: ILayoutContextData;
  dispatch: Dispatch<ILayoutReducerAction>;
}

export interface ILayoutProviderProps extends ILayoutContextData {
  layoutMode?: string;
}

export const LayoutContext = createContext<ILayoutContext>({} as ILayoutContext);

export const LayoutProvider = ({ children, ...props }: PropsWithChildren<ILayoutProviderProps>) => {
  const [context, dispatch] = useReducer(layoutReducer, props);

  const providerValue = {
    context,
    dispatch,
  };

  useEffect(() => {
    console.info(`[LayoutProvider] mode: ${props.layoutMode}`);
  }, []);

  return <LayoutContext.Provider value={providerValue}>{children}</LayoutContext.Provider>;
};
